export default __webpack_public_path__ + "static/media/front.379a6834.webp";